import {Button, TextInput} from "omoplay";
import InputGroup from "../InputGroup";
import {getMetaTag, postMetaTagSave} from "../../../api/project/project.api";
import ImageForm from "../../ImageForm";
import {useEffect, useState} from "react";
import MessageWrapPreview from "../../volatility-message/content/preview/MessageWrapPreview";

const ProjectDetailMetaTag = ({projectId}) => {
    const [name, setName] = useState()
    const [imageUrl, setImageUrl] = useState()
    const [description, setDescription] = useState()

    useEffect(() => {
        getMetaTag(projectId).then(({data}) => {
            setName(data?.name)
            setImageUrl(data?.imageUrl)
            setDescription(data?.description)
        })
    }, []);

    return (
        <>
            <InputGroup label={
                <div className="flex-align-center justify-between">
                    <div className="text-[16px] font-bold text-gray-900">URL 미리보기 내용 수정</div>
                    <Button variants="dark" value="적용하기" onClick={() => {
                        if (window.confirm("어플리케이션 마다 정책으로 인해 바로 적용이 되지 않을 수 있습니다.\n진행 하시겠습니까?")) {
                            postMetaTagSave(projectId, name, imageUrl, description).then(() => {
                                alert("저장 되었습니다.")
                            })
                        }
                    }} />
                </div>
            } description="예시 화면은 카카오톡 기준이며 어플리케이션 마다 차이가 있습니다.">
                <div className="flex gap-4">
                    <div className="flex-1 flex-col gap-4">
                        <InputGroup label="제목">
                            <TextInput placeholder="제목" value={name} onChange={(e) => setName(e.target.value)} />
                        </InputGroup>
                        <InputGroup label="이미지">
                            <ImageForm imageUrl={imageUrl} onChangeImageUrl={setImageUrl} />
                        </InputGroup>
                        <InputGroup label="내용">
                        <textarea className="border-2 w-full h-[100px]" value={description}
                                  onChange={(e) => setDescription(e.target.value)} />
                        </InputGroup>
                    </div>
                    <div className="flex-1 flex-col items-center">
                        <MessageWrapPreview type="FI" messageData={{image: {imgUrl: imageUrl ?? "https://"},
                            content: <div>
                                <div className="text-[13px] font-semibold">{name}</div>
                                <div className="text-[12px] text-ellipsis">{description?.substring(0, 40).replaceAll("\n", "")}..</div>
                                <div className="text-primary underline">omopl.com</div>
                            </div>
                        }} style={{width: "500px"}} />
                    </div>
                </div>
            </InputGroup>
        </>
    )
}

export default ProjectDetailMetaTag